import { cloneElement, Fragment } from 'react';
import FocusLock from 'react-focus-lock';
import { RemoveScroll } from 'react-remove-scroll';
import { useFloatingPosition, useIsMobile, useTransitionState } from 'modules/hooks';
import { useGeneratedId } from 'modules/utils';
import { Portal } from 'modules/v2/foundation/PortalProvider/Portal';
import { Container } from './styled';
export function Popover(props) {
    const { target, children, open, padding = '2xl', placement = 'bottom-start', offset, shadow = '300', closeOnOutsideClick = true, lockGroupId, onClose, } = props;
    const state = useTransitionState(open, 200);
    const { refs, wrapperStyle } = useFloatingPosition({
        active: true,
        options: {
            placement,
        },
        offset,
        outsideClickTrigger: () => {
            if (open && closeOnOutsideClick) {
                onClose();
            }
        },
    });
    const uniqueId = useGeneratedId('popover');
    const isMobile = useIsMobile();
    const clonedTargetWithRef = cloneElement(target, {
        ref: refs.setReference,
        'aria-haspopup': 'menu',
        'aria-expanded': `${open}`,
    });
    const shouldRender = state !== 'hidden';
    return (<Fragment>
      {clonedTargetWithRef}

      {shouldRender && (<Portal>
          <RemoveScroll enabled={isMobile && open}>
            <Container role="menu" ref={refs.setFloating} style={wrapperStyle} $state={state} $padding={padding} $shadow={shadow}>
              <FocusLock group={lockGroupId || uniqueId} disabled={!open} shards={[refs.reference]}>
                {children}
              </FocusLock>
            </Container>
          </RemoveScroll>
        </Portal>)}
    </Fragment>);
}
